import { render, staticRenderFns } from "./MethodDetail.vue?vue&type=template&id=7bdd5676"
import script from "./MethodDetail.vue?vue&type=script&lang=js"
export * from "./MethodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports